var map = {
	"./en/btn_9_2.png": "GB6F",
	"./es/btn_9_2.png": "MdMT",
	"./pt/btn_9_2.png": "JDk3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rzTb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_9_2\.png$
// module id = rzTb
// module chunks = 0